"use client";

import { c as _c } from "react/compiler-runtime";
import { useAnalytics } from "@/contexts/analytics-context";
export const useAs146Decision = () => {
  const $ = _c(6);
  const {
    optimizelyDecisionsRan,
    getOptimizelyDecisionInfo
  } = useAnalytics();
  let t0;
  if ($[0] !== getOptimizelyDecisionInfo) {
    t0 = getOptimizelyDecisionInfo("AS146");
    $[0] = getOptimizelyDecisionInfo;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const variationKeyAs146 = t0;
  const shouldRunAs146 = optimizelyDecisionsRan && variationKeyAs146 && variationKeyAs146 !== "control";
  let t1;
  if ($[2] !== optimizelyDecisionsRan || $[3] !== shouldRunAs146 || $[4] !== variationKeyAs146) {
    t1 = {
      isDecisionReadyForAs146: optimizelyDecisionsRan,
      shouldRunAs146,
      variationKeyAs146
    };
    $[2] = optimizelyDecisionsRan;
    $[3] = shouldRunAs146;
    $[4] = variationKeyAs146;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  return t1;
};